import * as React from "react";
import { authManager } from "../global";

export default () => <span>{authManager.userName}</span>;
